import React from "react";
import { Loader2 } from "lucide-react";
import { cn } from "../../lib/utils";

const Spinner = ({ className, size = 32, label }) => (
  <div className={cn("flex flex-col items-center justify-center gap-3", className)} role="status">
    <Loader2 size={size} className="text-red-700 animate-spin" aria-hidden="true" />
    {label && <p className="text-base font-medium text-slate-800 text-center">{label}</p>}
    <span className="sr-only">{label || "Loading"}</span>
  </div>
);

export default Spinner;
